import { render, staticRenderFns } from "./pic_index.vue?vue&type=template&id=6140078d&scoped=true"
import script from "./pic_index.vue?vue&type=script&lang=js"
export * from "./pic_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140078d",
  null
  
)

export default component.exports